<template>
  <b-overlay
    :show="loader"
    rounded="sm"
  >
    <b-card
      no-body
      class="business-card"
    >
      <b-card-header class="pb-1">
        <b-card-title>Dependencias encontradas</b-card-title>
        <!-- <feather-icon
          v-b-tooltip.hover.v-secondary.top="'Volver a cargar'"
          icon="RepeatIcon"
          size="18"
          class="cursor-pointer"
        /> -->
      </b-card-header>

      <b-card-body>
        <b-card-text>Hemos encontrado las siguientes coincidencias relacionadas al RFC: "<b class="text-primary">{{ searchInput }}</b>"</b-card-text>
        <!-- Buscador de dependencias -->
        <b-form-group>
          <b-input-group>
            <!-- Campo de texto para búsqueda -->
            <b-form-input
              v-model="searchInput"
              placeholder="Ingrese dependencia"
            />
            <!-- Botón de búsqueda -->
            <b-input-group-append
              v-b-tooltip.hover.v-secondary.top="'Buscar dependencias'"
              is-text
              @click="search()"
            >
              <feather-icon
                icon="SearchIcon"
                class="cursor-pointer"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!-- Si tengo dependencias -->
        <div
          v-if="dependencias.length > 0"
          class="business-items mt-1"
        >
          <div
            v-for="dep in dependencias"
            :key="dep.id_dependencia"
            v-b-modal.modal-lg
            v-b-tooltip.hover.v-secondary.right="'Click para ver detalles de dependencia'"
            class="business-item cursor-pointer"
          >
            <div class="d-flex align-items-center justify-content-between">
              <b>{{ dep.dependencia }}</b>
              <b-badge variant="primary">
                {{ dep.entidadFederativa.nombre }}
              </b-badge>
            </div>
          </div>
        </div>
        <!-- Sino -->
        <div
          v-else
          class="p-0 text-center"
        >
          <span>No hay resultados para mostrar</span>
        </div>
      </b-card-body>
    </b-card>

    <b-modal
      id="modal-lg"
      ok-only
      ok-title="Accept"
      centered
      size="lg"
    >
      <!-- Modal Header -->
      <template #modal-header>
        <h5 class="modal-title">
          Detalles de dependencia
        </h5>
        <div class="modal-actions">
          <feather-icon
            v-b-tooltip.hover.v-secondary.top="'Recargar datos'"
            icon="RepeatIcon"
            class="cursor-pointer"
          />
          <feather-icon
            v-b-modal.modal-lg
            v-b-tooltip.hover.v-secondary.top="'Cerrar ventana emergente'"
            icon="XIcon"
            class="ml-1 cursor-pointer"
          />
        </div>
      </template>

      <b-row>
        <b-col
          md="6"
          sm="12"
        >
          Datos de dependencia seleccionada
        </b-col>

        <b-col
          md="6"
          sm="12"
        >
          <detalle-sugerencia :data="data" />
        </b-col>
      </b-row>

      <!-- <b-card-text>Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw caramels. I love marshmallow tiramisu I love fruitcake I love gummi bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I love. Donut powder cupcake ice cream tootsie roll jelly.</b-card-text> -->
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BCardText,
  VBTooltip,
  BOverlay,
  // BFormCheckbox,
  BFormInput,
  BInputGroup,
  BFormGroup,
  BInputGroupAppend,
  BBadge,
  BModal,
  VBModal,
  BRow,
  BCol,
  // BMedia,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { isObject, isEmptyObject } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DetalleSugerencia from './components/DetalleSugerencia.vue'
import { searchDependency } from '../../useServicioEscolar'

export default {
  components: {
    BCard,
    BBadge,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BOverlay,
    BFormInput,
    BInputGroup,
    BFormGroup,
    BInputGroupAppend,
    BModal,
    DetalleSugerencia,
    BRow,
    BCol,
    // BMedia,
    // BFormCheckbox,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      businessItems: [
        {
          option: 'Option #1', money: '+$39', badgeColor: 'light-success', checked: false,
        },
        {
          option: 'Option #2', money: '+85', badgeColor: 'light-primary', checked: true,
        },
        {
          option: 'Option #3', money: '+$199', badgeColor: 'light-success', checked: false,
        },
        {
          option: 'Option #4', money: '+$459', badgeColor: 'light-success', checked: false,
        },
      ],
    }
  },
  setup(props) {
    const toast = useToast()
    const loader = ref(false)
    const searchInput = ref('')
    const dependencias = ref([])

    //* Load data
    // eslint-disable-next-line no-unused-vars
    const search = () => {
      if (searchInput.value.length > 0) {
        loader.value = true
        searchDependency(searchInput.value).then(response => {
          loader.value = false
          dependencias.value = response
        }, error => {
          loader.value = false
          dependencias.value = []
          toast({
            component: ToastificationContent,
            props: {
              title: 'Buscador de dependencia',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      }
    }

    //* Watch the data object, to get rfc and set in searchInput
    watch(() => props.data, data => {
      if (!isEmptyObject(data) && isObject(data)) {
        searchInput.value = data.rfc
        search()
      }
    })

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    // search()
    return {
      dependencias,
      searchInput,
      perfectScrollbarSettings,

      // Methods
      search,

      // Loader
      loader,
    }
  },
}
</script>
